import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import isValid from 'date-fns/isValid';
import { required, resolveNopeRefs } from './shared';
import type { FieldError, NopeContext, ObjectShape, ValidationRule } from './shared';
import type NopeReference from './ref';

type DateInput = string | number | Date;

const isValidDate =
  (message: string): ValidationRule =>
  (value, context) => {
    const resolvedDate = resolveNopeRefs(value, context) as DateInput;

    return !isValid(new Date(resolvedDate)) && message;
  };

const before =
  (date: DateInput | NopeReference, message: string): ValidationRule =>
  (value, context) => {
    const resolvedDate = resolveNopeRefs(date, context) as DateInput;

    return !isBefore(new Date(value as DateInput), new Date(resolvedDate)) && message;
  };

const after =
  (date: DateInput | NopeReference, message: string): ValidationRule =>
  (value, context) => {
    const resolvedDate = resolveNopeRefs(date, context) as DateInput;

    return !isAfter(new Date(value as DateInput), new Date(resolvedDate)) && message;
  };

class NopeDate {
  validationRules: ValidationRule[] = [];

  required(message = 'This field is required'): this {
    this.validationRules.push(required(message));

    return this;
  }

  valid(message = 'Input is not a valid date'): this {
    this.validationRules.push(isValidDate(message));

    return this;
  }

  before(date: DateInput | NopeReference, message = `Date must be before ${date}`): this {
    this.validationRules.push(before(date, message));

    return this;
  }

  after(date: DateInput | NopeReference, message = `Date must be after ${date}`): this {
    this.validationRules.push(after(date, message));

    return this;
  }

  validate(entry: unknown, context?: NopeContext, objectShape?: ObjectShape): FieldError {
    for (const fn of this.validationRules) {
      const error = fn(entry, context, objectShape);

      if (error) {
        return error;
      }
    }
  }
}

export default NopeDate;
